// extracted by mini-css-extract-plugin
export default {"fileContainer":"FileCard_fileContainer__qsHVh","innerContainer":"FileCard_innerContainer__-lMFM","uploadIcon":"FileCard_uploadIcon__ELUqh","fileName":"FileCard_fileName__2l-vl"};